module.exports = __webpack_public_path__ + "img/parthner-5.59e6393a.svg";